import {css} from "@panda/css";

import {GoToPortalButton} from "./GoToPortalButton";
import {NavLogo} from "./NavLogo";
import {UserProfileMenu} from "./UserProfileMenu";

export const MobileHeader = () => {
    return (
        <header className={mobileHeaderStyle}>
            <div className={brandStyle}>
                <NavLogo />
                <GoToPortalButton />
            </div>

            <UserProfileMenu />
        </header>
    );
};

const brandStyle = css({
    alignItems: "center",
    display: "flex",
    gap: 1,
    minWidth: 0
});

const mobileHeaderStyle = css({
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    p: "1.2rem 0.4rem 0.8rem",
    width: "100%"
});
import {css} from "@panda/css";

import {GoToPortalButton} from "./GoToPortalButton";
import {NavLogo} from "./NavLogo";
import {UserProfileMenu} from "./UserProfileMenu";

export const MobileHeader = () => {
    return (
        <header className={mobileHeaderStyle}>
            <div className={brandStyle}>
                <NavLogo />
                <GoToPortalButton />
            </div>

            <UserProfileMenu />
        </header>
    );
};

const brandStyle = css({
    alignItems: "center",
    display: "flex",
    gap: 1,
    minWidth: 0
});

const mobileHeaderStyle = css({
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    p: "1.2rem 0.4rem 0.8rem",
    width: "100%"
});
